import { Button, Divider } from 'antd';
import { useTranslation } from 'react-i18next';

export interface SelectAllConfig {
  selectAllLabel?: React.ReactNode;
  unselectAllLabel?: React.ReactNode;
}

export type SelectAllOption = boolean | SelectAllConfig;

interface Props extends SelectAllConfig {
  menu: React.ReactElement;
  optionValues: string[];
  selectedValues?: string | string[];
  onChange: (value: string[]) => any;
}

export function SelectAllDropdown(props: Props) {
  const {
    menu,
    optionValues,
    selectedValues,
    onChange,
    selectAllLabel,
    unselectAllLabel,
  } = props;
  const { t } = useTranslation(undefined, { keyPrefix: 'selectAllDropdown' });
  const values = Array.isArray(selectedValues) ? selectedValues : [];
  const allSelected =
    optionValues.length > 0 &&
    optionValues.every((value) => values.includes(value));

  return (
    <>
      {menu}
      <Divider style={{ margin: '2px' }} />
      <div
        className="p-2"
        style={{ textAlign: 'center' }}
        onMouseDown={(event) => {
          event.preventDefault();
          event.stopPropagation();
        }}
      >
        <Button
          type="link"
          onClick={() => onChange(allSelected ? [] : optionValues)}
        >
          {allSelected
            ? unselectAllLabel ?? t('unselectAll')
            : selectAllLabel ?? t('selectAll')}
        </Button>
      </div>
    </>
  );
}
